import React from 'react'
import {makeStyles} from '@material-ui/core/styles'
import {Box, Button, Typography} from '@material-ui/core'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import ListItemText from '@material-ui/core/ListItemText'

const useStyles = makeStyles(theme => ({
    swipers: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    swipersEmpty: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '40px',
        maxWidth: 360,
        border: '1px dashed #DBDBDB',
        color: '#DBDBDB',
        backgroundColor: theme.palette.background.paper,
    },
    swipersNotAllowed: {
        border: '1px solid red',
        color: 'red',
    },
}))

const SwipeTeamDisplay = props => {
    const classes = useStyles()
    const {title, error, swiperarray, removeSwiper, disabledArchive} = props

    const swipearrayNotEmpty = Array.isArray(swiperarray)
        ? swiperarray.length > 0
        : false

    const errorNotEmpty = Array.isArray(error) ? error.length > 0 : false
    const errorMessage = Array.isArray(error) ? error.join() : ''

    return (
        <>
            <Typography variant="subtitle1">
                {title ? title : 'Swipers'}
            </Typography>

            {swipearrayNotEmpty ? (
                <Box className={errorNotEmpty ? classes.swipersNotAllowed : ''}>
                    <List dense className={classes.swipers}>
                        {swiperarray.map(value => {
                            const labelId = `swiper-label-${value.euid}`
                            return (
                                <ListItem
                                    key={value.euid}
                                    button
                                    disabled={disabledArchive}
                                >
                                    <ListItemText
                                        id={labelId}
                                        primary={
                                            <>
                                                <b>{value.name}</b> {value.euid}
                                            </>
                                        }
                                        style={{maxWidth: '280px'}}
                                    />
                                    <ListItemSecondaryAction
                                        style={{right: '0px'}}
                                    >
                                        <Button
                                            edge="end"
                                            variant="text"
                                            size="small"
                                            onClick={() =>
                                                removeSwiper(value.euid)
                                            }
                                            style={{color: '#098447'}}
                                            disabled={disabledArchive}
                                        >
                                            REMOVE
                                        </Button>
                                    </ListItemSecondaryAction>
                                </ListItem>
                            )
                        })}
                    </List>
                    {errorMessage}
                </Box>
            ) : (
                <Box className={classes.swipersEmpty}> List Empty </Box>
            )}
        </>
    )
}

export default SwipeTeamDisplay
